import { useAuth0 } from "@auth0/auth0-react";
import { useCallback } from "react";
import { buildRedirectURI } from "./login-button-with-redirect";

export const useGetAccessToken = (audience) => {
  const { getAccessTokenSilently, getAccessTokenWithPopup } = useAuth0();
  return useCallback(async (scope = '') => {
    const redirect_uri = buildRedirectURI();
    try {
      const token = await getAccessTokenSilently({ audience, scope, redirect_uri, detailedResponse: true });
      return token;
    } catch (error) {
      // If consent is required or login is required, use popup to get consent
      if (error.error === 'consent_required' || error.error === 'login_required') {
        const token = await getAccessTokenWithPopup({ audience, scope, redirect_uri, detailedResponse: true });
        return token;
      }
      throw error;
    }
  }, [getAccessTokenSilently, getAccessTokenWithPopup, audience]);
}

export const useAuthUser = () => {
  const { user } = useAuth0();
  return user;
}

export const useIsAuthenticated = () => {
  const { isAuthenticated } = useAuth0();
  return isAuthenticated;
}
